import { ScriptingRuntime } from '../../nr-scripting-runtime/core/ScriptingRuntime';
import * as THREE from 'three';
import BehaviourObject from "../entities/BehaviourObject";
import { proxyUrl, proxyUrlShortenerMS } from '../utils/media-url-utils';

AFRAME.registerSystem("scripting", {
  init: function () {
    if (typeof window.module === 'undefined') {
      window.module = { exports: {} };
    }
    globalThis.THREE = THREE;
    this.scriptingRuntime = new ScriptingRuntime({devMode: false, proxyUrl: proxyUrlShortenerMS});
    this.el.sceneEl.addEventListener('environment-scene-loaded', () => {
      this.startTick = true;
      this.initializeScriptingRuntime();
    });
    this.behaviors = []; // Array to store registered behaviors
  },
  initializeScriptingRuntime: async function () {

    // Step 1: Collect all behaviors
    const behaviours = Array.from(document.querySelectorAll("[behaviour]"));

    // Step 2: Sort behaviors by executionIndex
    behaviours.sort((a, b) => {
      const indexA = a.getAttribute("behaviour").executionIndex;
      const indexB = b.getAttribute("behaviour").executionIndex;
      return indexA - indexB;
    });

    for (const el of behaviours) {
      const behaviourComponent = el.components.behaviour;
      await behaviourComponent.register(); // Await the registration in order
    }
  },

  tick: function(time, dt) {
    if(this.startTick === false) return;
    const newTime = time / 1000;
    const newDt = dt / 1000;
    this.scriptingRuntime.tick(newDt, newTime);
  }
  
});

AFRAME.registerComponent("behaviour", {
  schema: {
    code: { default: '' },
    executionIndex: { type: 'number', default: 0 }
  },
  async register() {
      this.scriptingRuntime = AFRAME.scenes[0].systems.scripting.scriptingRuntime;
      this.el.object3D.code = this.data.code;
      this.el.object3D.enabled = true;

        // First, store the original clone method
        const originalClone = this.el.object3D.clone.bind(this.el.object3D);

        // Override the clone method
        this.el.object3D.clone = () => {
            // Call the original clone method
            const cl = originalClone();

            // Assign the 'code' property to the cloned object
            cl.code = this.data.code;
            cl.executionIndex = this.data.executionIndex
            return cl;
        };

      const camera = document.querySelector("#viewing-camera")?.object3D.children[0];

      await this.scriptingRuntime.registerBehaviourNode(
        this.el.object3D, { 
          scene: AFRAME.scenes[0].object3D, THREE, camera,
          renderer: AFRAME.scenes[0].renderer,
          audioListener: APP.audioListener,
        })
  },
  remove() {
    this.scriptingRuntime.unregisterBehaviourNode(this.el.object3D);
  }
});
